import gql from 'graphql-tag';

export default gql`
  mutation updateOrderExerciseLessonMutation($_id: MongoID!, $record: UpdateOrderExerciseLessonInput!) {
    updateOrderExerciseLessonMutation(_id: $_id, record: $record) {
      recordId
      record {
        status
      }
    }
  }
`;
